module.exports = __webpack_public_path__ + "static/media/genetic-variants.fc4af947.svg";